import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({ selector: '[myPhoneOnly]' })
export class TextPhoneOnlyDirective {
    private el = inject(ElementRef);

    // Allow decimal numbers and negative values
    private regex = new RegExp(/^[0-9]{0,30}$/g);
    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    private specialKeys: string[] = [
        'Backspace',
        'Tab',
        'End',
        'Home',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Delete'
    ];


    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const current: string = this.el.nativeElement.value;
        const next: string = current.concat(event.key);
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}
